import { render, staticRenderFns } from "./note_header.vue?vue&type=template&id=27d81fa9&"
import script from "./note_header.vue?vue&type=script&lang=js&"
export * from "./note_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports